const pokeTypes = [
    ["grass", "poison"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["fire"],
    ["fire"],
    ["fire", "flying"],
    ["water"],
    ["water"],
    ["water"],
    ["bug"],
    ["bug"],
    ["bug", "flying"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal"],
    ["normal"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["poison"],
    ["poison"],
    ["electric"],
    ["electric"],
    ["ground"],
    ["ground"],
    ["poison"],
    ["poison"],
    ["poison", "ground"],
    ["poison"],
    ["poison"],
    ["poison", "ground"],
    ["fairy"],
    ["fairy"],
    ["fire"],
    ["fire"],
    ["normal", "fairy"],
    ["normal", "fairy"],
    ["poison", "flying"],
    ["poison", "flying"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["bug", "grass"],
    ["bug", "grass"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["ground"],
    ["ground"],
    ["normal"],
    ["normal"],
    ["water"],
    ["water"],
    ["fighting"],
    ["fighting"],
    ["fire"],
    ["fire"],
    ["water"],
    ["water"],
    ["water", "fighting"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["fighting"],
    ["fighting"],
    ["fighting"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["water", "poison"],
    ["water", "poison"],
    ["rock", "ground"],
    ["rock", "ground"],
    ["rock", "ground"],
    ["fire"],
    ["fire"],
    ["water", "psychic"],
    ["water", "psychic"],
    ["electric", "steel"],
    ["electric", "steel"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["water"],
    ["water", "ice"],
    ["poison"],
    ["poison"],
    ["water"],
    ["water", "ice"],
    ["ghost", "poison"],
    ["ghost", "poison"],
    ["ghost", "poison"],
    ["rock", "ground"],
    ["psychic"],
    ["psychic"],
    ["water"],
    ["water"],
    ["electric"],
    ["electric"],
    ["grass", "psychic"],
    ["grass", "psychic"],
    ["ground"],
    ["ground"],
    ["fighting"],
    ["fighting"],
    ["normal"],
    ["poison"],
    ["poison"],
    ["ground", "rock"],
    ["ground", "rock"],
    ["normal"],
    ["grass"],
    ["normal"],
    ["water"],
    ["water"],
    ["water"],
    ["water"],
    ["water"],
    ["water", "psychic"],
    ["psychic", "fairy"],
    ["bug", "flying"],
    ["ice", "psychic"],
    ["electric"],
    ["fire"],
    ["bug"],
    ["normal"],
    ["water"],
    ["water", "flying"],
    ["water", "ice"],
    ["normal"],
    ["normal"],
    ["water"],
    ["electric"],
    ["fire"],
    ["normal"],
    ["rock", "water"],
    ["rock", "water"],
    ["rock", "water"],
    ["rock", "water"],
    ["rock", "flying"],
    ["normal"],
    ["ice", "flying"],
    ["electric", "flying"],
    ["fire", "flying"],
    ["dragon"],
    ["dragon"],
    ["dragon", "flying"],
    ["psychic"],
    ["psychic"],
    ["grass"],
    ["grass"],
    ["grass"],
    ["fire"],
    ["fire"],
    ["fire"],
    ["water"],
    ["water"],
    ["water"],
    ["normal"],
    ["normal"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["bug", "flying"],
    ["bug", "flying"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["poison", "flying"],
    ["water", "electric"],
    ["water", "electric"],
    ["electric"],
    ["fairy"],
    ["normal", "fairy"],
    ["fairy"],
    ["fairy", "flying"],
    ["psychic", "flying"],
    ["psychic", "flying"],
    ["electric"],
    ["electric"],
    ["electric"],
    ["grass"],
    ["water", "fairy"],
    ["water", "fairy"],
    ["rock"],
    ["water"],
    ["grass", "flying"],
    ["grass", "flying"],
    ["grass", "flying"],
    ["normal"],
    ["grass"],
    ["grass"],
    ["bug", "flying"],
    ["water", "ground"],
    ["water", "ground"],
    ["psychic"],
    ["dark"],
    ["dark", "flying"],
    ["water", "psychic"],
    ["ghost"],
    ["psychic"],
    ["psychic"],
    ["normal", "psychic"],
    ["bug"],
    ["bug", "steel"],
    ["normal"],
    ["ground", "flying"],
    ["steel", "ground"],
    ["fairy"],
    ["fairy"],
    ["water", "poison"],
    ["bug", "steel"],
    ["bug", "rock"],
    ["bug", "fighting"],
    ["dark", "ice"],
    ["normal"],
    ["normal"],
    ["fire"],
    ["fire", "rock"],
    ["ice", "ground"],
    ["ice", "ground"],
    ["water", "rock"],
    ["water"],
    ["water"],
    ["ice", "flying"],
    ["water", "flying"],
    ["steel", "flying"],
    ["dark", "fire"],
    ["dark", "fire"],
    ["water", "dragon"],
    ["ground"],
    ["ground"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["fighting"],
    ["fighting"],
    ["ice", "psychic"],
    ["electric"],
    ["fire"],
    ["normal"],
    ["normal"],
    ["electric"],
    ["fire"],
    ["water"],
    ["rock", "ground"],
    ["rock", "ground"],
    ["rock", "dark"],
    ["psychic", "flying"],
    ["fire", "flying"],
    ["psychic", "grass"],
    ["grass"],
    ["grass"],
    ["grass"],
    ["fire"],
    ["fire", "fighting"],
    ["fire", "fighting"],
    ["water"],
    ["water", "ground"],
    ["water", "ground"],
    ["dark"],
    ["dark"],
    ["normal"],
    ["normal"],
    ["bug"],
    ["bug"],
    ["bug", "flying"],
    ["bug"],
    ["bug", "poison"],
    ["water", "grass"],
    ["water", "grass"],
    ["water", "grass"],
    ["grass"],
    ["grass", "dark"],
    ["grass", "dark"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["water", "flying"],
    ["water", "flying"],
    ["psychic", "fairy"],
    ["psychic", "fairy"],
    ["psychic", "fairy"],
    ["bug", "water"],
    ["bug", "flying"],
    ["grass"],
    ["grass", "fighting"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["bug", "ground"],
    ["bug", "flying"],
    ["bug", "ghost"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["fighting"],
    ["fighting"],
    ["normal", "fairy"],
    ["rock"],
    ["normal"],
    ["normal"],
    ["dark", "ghost"],
    ["steel", "fairy"],
    ["steel", "rock"],
    ["steel", "rock"],
    ["steel", "rock"],
    ["fighting", "psychic"],
    ["fighting", "psychic"],
    ["electric"],
    ["electric"],
    ["electric"],
    ["electric"],
    ["bug"],
    ["bug"],
    ["grass", "poison"],
    ["poison"],
    ["poison"],
    ["water", "dark"],
    ["water", "dark"],
    ["water"],
    ["water"],
    ["fire", "ground"],
    ["fire", "ground"],
    ["fire"],
    ["psychic"],
    ["psychic"],
    ["normal"],
    ["ground"],
    ["ground", "dragon"],
    ["ground", "dragon"],
    ["grass"],
    ["grass", "dark"],
    ["normal", "flying"],
    ["dragon", "flying"],
    ["normal"],
    ["poison"],
    ["rock", "psychic"],
    ["rock", "psychic"],
    ["water", "ground"],
    ["water", "ground"],
    ["water"],
    ["water", "dark"],
    ["ground", "psychic"],
    ["ground", "psychic"],
    ["rock", "grass"],
    ["rock", "grass"],
    ["rock", "bug"],
    ["rock", "bug"],
    ["water"],
    ["water"],
    ["normal"],
    ["normal"],
    ["ghost"],
    ["ghost"],
    ["ghost"],
    ["ghost"],
    ["grass", "flying"],
    ["psychic"],
    ["dark"],
    ["psychic"],
    ["ice"],
    ["ice"],
    ["ice", "water"],
    ["ice", "water"],
    ["ice", "water"],
    ["water"],
    ["water"],
    ["water"],
    ["water", "rock"],
    ["water"],
    ["dragon"],
    ["dragon"],
    ["dragon", "flying"],
    ["steel", "psychic"],
    ["steel", "psychic"],
    ["steel", "psychic"],
    ["rock"],
    ["ice"],
    ["steel"],
    ["dragon", "psychic"],
    ["dragon", "psychic"],
    ["water"],
    ["ground"],
    ["dragon", "flying"],
    ["steel", "psychic"],
    ["psychic"],
    ["grass"],
    ["grass"],
    ["grass", "ground"],
    ["fire"],
    ["fire", "fighting"],
    ["fire", "fighting"],
    ["water"],
    ["water"],
    ["water", "steel"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal"],
    ["normal", "water"],
    ["bug"],
    ["bug"],
    ["electric"],
    ["electric"],
    ["electric"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["rock"],
    ["rock"],
    ["rock", "steel"],
    ["rock", "steel"],
    ["bug"],
    ["bug", "grass"],
    ["bug", "flying"],
    ["bug", "flying"],
    ["bug", "flying"],
    ["electric"],
    ["water"],
    ["water"],
    ["grass"],
    ["grass"],
    ["water"],
    ["water", "ground"],
    ["normal"],
    ["ghost", "flying"],
    ["ghost", "flying"],
    ["normal"],
    ["normal"],
    ["ghost"],
    ["dark", "flying"],
    ["normal"],
    ["normal"],
    ["psychic"],
    ["poison", "dark"],
    ["poison", "dark"],
    ["steel", "psychic"],
    ["steel", "psychic"],
    ["rock"],
    ["psychic", "fairy"],
    ["normal"],
    ["normal", "flying"],
    ["ghost", "dark"],
    ["dragon", "ground"],
    ["dragon", "ground"],
    ["dragon", "ground"],
    ["normal"],
    ["fighting"],
    ["fighting", "steel"],
    ["ground"],
    ["ground"],
    ["poison", "bug"],
    ["poison", "dark"],
    ["poison", "fighting"],
    ["poison", "fighting"],
    ["grass"],
    ["water"],
    ["water"],
    ["water", "flying"],
    ["grass", "ice"],
    ["grass", "ice"],
    ["dark", "ice"],
    ["electric", "steel"],
    ["normal"],
    ["ground", "rock"],
    ["grass"],
    ["electric"],
    ["fire"],
    ["fairy", "flying"],
    ["bug", "flying"],
    ["grass"],
    ["ice"],
    ["ground", "flying"],
    ["ice", "ground"],
    ["normal"],
    ["psychic", "fighting"],
    ["rock", "steel"],
    ["ghost"],
    ["ice", "ghost"],
    ["electric", "ghost"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["steel", "dragon"],
    ["water", "dragon"],
    ["fire", "steel"],
    ["normal"],
    ["ghost", "dragon"],
    ["psychic"],
    ["water"],
    ["water"],
    ["dark"],
    ["grass"],
    ["normal"],
    ["psychic", "fire"],
    ["grass"],
    ["grass"],
    ["grass"],
    ["fire"],
    ["fire", "fighting"],
    ["fire", "fighting"],
    ["water"],
    ["water"],
    ["water"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["normal"],
    ["dark"],
    ["dark"],
    ["grass"],
    ["grass"],
    ["fire"],
    ["fire"],
    ["water"],
    ["water"],
    ["psychic"],
    ["psychic"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["electric"],
    ["electric"],
    ["rock"],
    ["rock"],
    ["rock"],
    ["psychic", "flying"],
    ["psychic", "flying"],
    ["ground"],
    ["ground", "steel"],
    ["normal"],
    ["fighting"],
    ["fighting"],
    ["fighting"],
    ["water"],
    ["water", "ground"],
    ["water", "ground"],
    ["fighting"],
    ["fighting"],
    ["bug", "grass"],
    ["bug", "grass"],
    ["bug", "grass"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["bug", "poison"],
    ["grass", "fairy"],
    ["grass", "fairy"],
    ["grass"],
    ["grass"],
    ["water"],
    ["ground", "dark"],
    ["ground", "dark"],
    ["ground", "dark"],
    ["fire"],
    ["fire"],
    ["grass"],
    ["bug", "rock"],
    ["bug", "rock"],
    ["dark", "fighting"],
    ["dark", "fighting"],
    ["psychic", "flying"],
    ["ghost"],
    ["ghost"],
    ["water", "rock"],
    ["water", "rock"],
    ["rock", "flying"],
    ["rock", "flying"],
    ["poison"],
    ["poison"],
    ["dark"],
    ["dark"],
    ["normal"],
    ["normal"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["psychic"],
    ["water", "flying"],
    ["water", "flying"],
    ["ice"],
    ["ice"],
    ["ice"],
    ["normal", "grass"],
    ["normal", "grass"],
    ["electric", "flying"],
    ["bug"],
    ["bug", "steel"],
    ["grass", "poison"],
    ["grass", "poison"],
    ["water", "ghost"],
    ["water", "ghost"],
    ["water"],
    ["bug", "electric"],
    ["bug", "electric"],
    ["grass", "steel"],
    ["grass", "steel"],
    ["steel"],
    ["steel"],
    ["steel"],
    ["electric"],
    ["electric"],
    ["electric"],
    ["psychic"],
    ["psychic"],
    ["ghost", "fire"],
    ["ghost", "fire"],
    ["ghost", "fire"],
    ["dragon"],
    ["dragon"],
    ["dragon"],
    ["ice"],
    ["ice"],
    ["ice"],
    ["bug"],
    ["bug"],
    ["ground", "electric"],
    ["fighting"],
    ["fighting"],
    ["dragon"],
    ["ground", "ghost"],
    ["ground", "ghost"],
    ["dark", "steel"],
    ["dark", "steel"],
    ["normal"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["dark", "flying"],
    ["dark", "flying"],
    ["fire"],
    ["bug", "steel"],
    ["dark", "dragon"],
    ["dark", "dragon"],
    ["dark", "dragon"],
    ["bug", "fire"],
    ["bug", "fire"],
    ["steel", "fighting"],
    ["rock", "fighting"],
    ["grass", "fighting"],
    ["flying"],
    ["electric", "flying"],
    ["dragon", "fire"],
    ["dragon", "electric"],
    ["ground", "flying"],
    ["dragon", "ice"],
    ["water", "fighting"],
    ["normal", "psychic"],
    ["bug", "steel"],
    ["grass"],
    ["grass"],
    ["grass", "fighting"],
    ["fire"],
    ["fire"],
    ["fire", "psychic"],
    ["water"],
    ["water"],
    ["water", "dark"],
    ["normal"],
    ["normal", "ground"],
    ["normal", "flying"],
    ["fire", "flying"],
    ["fire", "flying"],
    ["bug"],
    ["bug"],
    ["bug", "flying"],
    ["fire", "normal"],
    ["fire", "normal"],
    ["fairy"],
    ["fairy"],
    ["fairy"],
    ["grass"],
    ["grass"],
    ["fighting"],
    ["fighting", "dark"],
    ["normal"],
    ["psychic"],
    ["psychic"],
    ["steel", "ghost"],
    ["steel", "ghost"],
    ["steel", "ghost"],
    ["fairy"],
    ["fairy"],
    ["fairy"],
    ["fairy"],
    ["dark", "psychic"],
    ["dark", "psychic"],
    ["rock", "water"],
    ["rock", "water"],
    ["poison", "water"],
    ["poison", "dragon"],
    ["water"],
    ["water"],
    ["electric", "normal"],
    ["electric", "normal"],
    ["rock", "dragon"],
    ["rock", "dragon"],
    ["rock", "ice"],
    ["rock", "ice"],
    ["fairy"],
    ["fighting", "flying"],
    ["electric", "fairy"],
    ["rock", "fairy"],
    ["dragon"],
    ["dragon"],
    ["dragon"],
    ["steel", "fairy"],
    ["ghost", "grass"],
    ["ghost", "grass"],
    ["ghost", "grass"],
    ["ghost", "grass"],
    ["ice"],
    ["ice"],
    ["flying", "dragon"],
    ["flying", "dragon"],
    ["fairy"],
    ["dark", "flying"],
    ["dragon", "ground"],
    ["rock", "fairy"],
    ["psychic", "ghost"],
    ["fire", "water"],
    ["grass", "flying"],
    ["grass", "flying"],
    ["grass", "ghost"],
    ["fire"],
    ["fire"],
    ["fire", "dark"],
    ["water"],
    ["water"],
    ["water", "fairy"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal", "flying"],
    ["normal"],
    ["normal"],
    ["bug"],
    ["bug", "electric"],
    ["bug", "electric"],
    ["fighting"],
    ["fighting", "ice"],
    ["fire", "flying"],
    ["bug", "fairy"],
    ["bug", "fairy"],
    ["rock"],
    ["rock"],
    ["water"],
    ["poison", "water"],
    ["poison", "water"],
    ["ground"],
    ["ground"],
    ["water", "bug"],
    ["water", "bug"],
    ["grass"],
    ["grass"],
    ["grass", "fairy"],
    ["grass", "fairy"],
    ["poison", "fire"],
    ["poison", "fire"],
    ["normal", "fighting"],
    ["normal", "fighting"],
    ["grass"],
    ["grass"],
    ["grass"],
    ["fairy"],
    ["normal", "psychic"],
    ["fighting"],
    ["bug", "water"],
    ["bug", "water"],
    ["ghost", "ground"],
    ["ghost", "ground"],
    ["water"],
    ["normal"],
    ["normal"],
    ["rock", "flying"],
    ["normal"],
    ["fire", "dragon"],
    ["electric", "steel"],
    ["ghost", "fairy"],
    ["water", "psychic"],
    ["normal", "dragon"],
    ["ghost", "grass"],
    ["dragon"],
    ["dragon", "fighting"],
    ["dragon", "fighting"],
    ["electric", "fairy"],
    ["psychic", "fairy"],
    ["grass", "fairy"],
    ["water", "fairy"],
    ["psychic"],
    ["psychic"],
    ["psychic", "steel"],
    ["psychic", "ghost"],
    ["rock", "poison"],
    ["bug", "fighting"],
    ["bug", "fighting"],
    ["electric"],
    ["steel", "flying"],
    ["grass", "steel"],
    ["dark", "dragon"],
    ["psychic"],
    ["steel", "fairy"],
    ["fighting", "ghost"],
    ["poison"],
    ["poison", "dragon"],
    ["rock", "steel"],
    ["fire", "ghost"],
    ["electric"],
    ["steel"],
    ["steel"],
    ["grass"],
    ["grass"],
    ["grass"],
    ["fire"],
    ["fire"],
    ["fire"],
    ["water"],
    ["water"],
    ["water"],
    ["normal"],
    ["normal"],
    ["flying"],
    ["flying"],
    ["flying", "steel"],
    ["bug"],
    ["bug", "psychic"],
    ["bug", "psychic"],
    ["dark"],
    ["dark"],
    ["grass"],
    ["grass"],
    ["normal"],
    ["normal"],
    ["water"],
    ["water", "rock"],
    ["electric"],
    ["electric"],
    ["rock"],
    ["rock", "fire"],
    ["rock", "fire"],
    ["grass", "dragon"],
    ["grass", "dragon"],
    ["grass", "dragon"],
    ["ground"],
    ["ground"],
    ["flying", "water"],
    ["water"],
    ["water"],
    ["electric", "poison"],
    ["electric", "poison"],
    ["fire", "bug"],
    ["fire", "bug"],
    ["fighting"],
    ["fighting"],
    ["ghost"],
    ["ghost"],
    ["psychic"],
    ["psychic"],
    ["psychic", "fairy"],
    ["dark", "fairy"],
    ["dark", "fairy"],
    ["dark", "fairy"],
    ["dark", "normal"],
    ["steel"],
    ["ghost"],
    ["fighting"],
    ["ice", "psychic"],
    ["ground", "ghost"],
    ["fairy"],
    ["fairy"],
    ["fighting"],
    ["electric"],
    ["ice", "bug"],
    ["ice", "bug"],
    ["rock"],
    ["ice"],
    ["psychic", "normal"],
    ["electric", "dark"],
    ["steel"],
    ["steel"],
    ["electric", "dragon"],
    ["electric", "ice"],
    ["water", "dragon"],
    ["water", "ice"],
    ["steel", "dragon"],
    ["dragon", "ghost"],
    ["dragon", "ghost"],
    ["dragon", "ghost"],
    ["fairy"],
    ["fighting"],
    ["poison", "dragon"],
    ["fighting"],
    ["fighting", "dark"],
    ["dark", "grass"]
];

export default pokeTypes;
